// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"667":"8506c681","741":"88d428e7","865":"5d23003e"}[chunkId] + ".css";
};